import { render, staticRenderFns } from "./MonthlyWiseShipmenrProfitReport.vue?vue&type=template&id=41489558&"
import script from "./MonthlyWiseShipmenrProfitReport.vue?vue&type=script&lang=js&"
export * from "./MonthlyWiseShipmenrProfitReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports